module.exports = __webpack_public_path__ + "img/obpfar.f1783f13.jpg";